 <layout>
          <div class="container" [ngStyle]="{
              'position': url == '/' || url == '/home' ? 'absolute' : 'relative',
              'background-color': url == '/' || url == '/home' ? 'transparent' : 'rgba(74,130,155,1)'
            }"
            [ngClass]="{
                'athome': url == '/' || url == '/home', 
                'notHome': url != '/' && url != '/home'  
            }"
            
            >
            <div  routerLink="/" id="logo"></div>
            <div  class="links desktop" >
                <a *ngIf="!!profile && !!hasOrg" routerLink="/my-school" >{{config?.navSchool}}</a>
                <a *ngIf="!!profile && !profile.organization" routerLink="/my-lessons" >{{config?.navMyGuides}}</a>
                <a *ngIf=!profile routerLink="/my-lessons"  >{{config?.navGuides}}</a>
                <a routerLink="/contact-us" >{{config?.navContactUs}}</a>
                <a *ngIf="!!profile && !hasOrg" routerLink="/messages" >{{config?.navMessages}}</a>
                <a *ngIf=!profile  (click)="showSignUp()">{{config?.navRegister}}</a>                        
                <a *ngIf=!profile  (click)="showLogin()" >{{config?.navLogin}}</a>
                <a *ngIf="!!profile"  (click)="logout()" >{{config?.navLogout}}</a>
              

                <a [@trigger] *ngIf=!!profile class="name"routerLink="/profile"
                    matTooltip="Click to view your profile"
                >
                    {{config?.navHi}} {{profile?.firstname}} 👋
                </a>
            </div>
            <div class="mobile">
                <button mat-button [matMenuTriggerFor]="menu">
                    <mat-icon aria-hidden="false" aria-label="Example home icon">menu</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item routerLink="/" >Home</button>
                    <button mat-menu-item *ngIf="!!profile && !!hasOrg" routerLink="/my-school" >My School</button>
                    <button mat-menu-item *ngIf="!!profile && !profile.organization" routerLink="/my-lessons" >My Guides</button>
                    <button mat-menu-item *ngIf=!profile routerLink="/my-lessons"  >Guides</button>
                    <button mat-menu-item *ngIf=!!profile routerLink="/profile"  >Settings</button>
                    <button mat-menu-item routerLink="/contact-us" >Contact Us</button>
                    <button mat-menu-item  *ngIf="!!profile && !hasOrg" routerLink="/messages" >Messages</button>
                    <button mat-menu-item *ngIf=!profile  (click)="showSignUp()">Register</button>                       
                    <button mat-menu-item *ngIf=!profile  (click)="showLogin()" >Login</button>
                    <button mat-menu-item *ngIf="!!profile"  (click)="logout()" >Logout</button>
                </mat-menu>
            </div>
        </div>
        <div>           
      </div>
  

</layout>
  
  
  